export const formatDate = (createdAtDate?: Date, updatedAtDate?: Date) => {
  if (!createdAtDate) return "";

  const dateToUse =
    updatedAtDate && updatedAtDate.getFullYear() !== 1
      ? { date: updatedAtDate, prefix: "(Redigeret) " }
      : { date: createdAtDate, prefix: "" };

  const hours = dateToUse.date.getHours().toString().padStart(2, "0");
  const minutes = dateToUse.date.getMinutes().toString().padStart(2, "0");
  const day = dateToUse.date.getDate().toString().padStart(2, "0");
  const month = (dateToUse.date.getMonth() + 1).toString().padStart(2, "0");
  const year = dateToUse.date.getFullYear().toString().slice(-2);
  return `${dateToUse.prefix}${hours}:${minutes} - ${day}.${month}.${year}`;
};
